<template>
  <div style="margin-bottom: 30px">
    <div class="mapTitle" v-if="$route.params.type==1">青岛辖区证券经营机构分布图</div>
    <div class="mapTitle" v-if="$route.params.type==2">青岛辖区期货经营机构分布图</div>
    <div ref="qdmap" class="qdmap" ></div>
    <div class="line">
      <el-divider v-if="areaName!==''" content-position="center">{{ this.areaName }}</el-divider>
    </div>
    <div style="width: 80%; margin: 0 auto">
      <el-table :data="table" :header-cell-style="{color:'black',fontSize:'18px',textAlign:'center'}">
        <el-table-column label="机构名称" prop="comName" align="left"/>
        <el-table-column label="详细地址" align="left" prop="addressWorking"/>
        <el-table-column label="联系电话" align="center" prop="telephoneOpen"/>
      </el-table>
      <pagination style="text-align: center" v-show="total>0" :total="total" :page.sync="queryParams.pageNum"
                  :limit.sync="queryParams.pageSize"
                  @pagination="getMember"/>
    </div>
  </div>
</template>

<script>
import mapJason from '../map/qdMap'
import * as echarts from "echarts";
import {getMember} from '../api/index'

export default {
  name: 'qdmap',

  data() {
    return {
      ress:null,
      total:0,
      areaName: '',
      table: [],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        industryType: this.$route.params.type,
        belongArea: null,
      },
      mapOption: {

        title: {
          text: "",
          subtext: "",
          sublink: ""
        },
        tooltip: {
          trigger: "item",

          formatter: (item)=>{


            getMember({
                pageNum: 1,
                pageSize: 10,
                industryType: this.queryParams.industryType,
                belongArea: item.data.e,
            }).then(res=>{

            this.ress=res
            })

            return item.data.name+':'+this.ress.data.data.total+'家'
          }
        },
        series: [
          {
            name: "ddd",
            type: "map",
            mapType: "QD", // 自定义扩展图表类型
            label: {
              show: true,
            },
            emphasis: {
              itemStyle: {
                areaColor: '#ee8355'
              }
            },


            // 鼠标移入区域，显示的名称和值
            data: [
              {name: "市南区", e: 1, itemStyle: {normal: {areaColor: '#82c5ef', label: {show: false}}}},
              {name: "市北区", e: 2, itemStyle: {normal: {areaColor: '#5fb1e5', label: {show: false}}}},
              {name: "崂山区", e: 3, itemStyle: {normal: {areaColor: '#a0c8f8', label: {show: false}}}},
              {name: "黄岛区", e: 4, itemStyle: {normal: {areaColor: '#b6e9fc', label: {show: false}}}},
              {name: "城阳区", e: 5, itemStyle: {normal: {areaColor: '#78aae8', label: {show: false}}}},
              {name: "李沧区", e: 6, itemStyle: {normal: {areaColor: '#82c5ef', label: {show: false}}}},
              {name: "胶州市", e: 7, itemStyle: {normal: {areaColor: '#abd1f8', label: {show: false}}}},
              {name: "莱西市", e: 8, itemStyle: {normal: {areaColor: '#7aabef', label: {show: false}}}},
              {name: "平度市", e: 9, itemStyle: {normal: {areaColor: '#9bd0fc', label: {show: false}}}},
              {name: "即墨区", e: 10, itemStyle: {normal: {areaColor: '#82c5ef', label: {show: false}}}},
            ]
            // 自定义名称映射
          }
        ]
      }
    }
  },

  mounted() {
    window.scroll(0, -0);
    let _this = this
    let myChart = echarts.init(this.$refs.qdmap);
    echarts.registerMap("QD", mapJason);
    myChart.setOption(this.mapOption);
    myChart.on('click', function (e) {
      console.log(e)
      // e.data.itemStyle={areaColor:'#ee83555'}
      _this.areaName = e.name;
      _this.queryParams.belongArea = e.data.e;
      getMember(_this.queryParams).then(res => {
        _this.table = res.data.data.rows;
        _this.total=res.data.data.total
      })

    })

  },
  created() {
    this.queryParams.industryType = this.$route.params.type;
  },
  methods: {
      getMember(){
        getMember(this.queryParams).then(res => {
          this.table = res.data.data.rows;
          this.total=res.data.data.total
        })
      }
  }
}
</script>

<style scoped>
.qdmap {
  height: 800px;
  width: 800px;
  margin: 0 auto;
}

.mapTitle {
  font-size: 20px;
  font-weight: bolder;
  text-align: center;
  margin-top: 30px;
}

.line {
  width: 300px;
  height: 50px;
  margin: 0 auto;
}

.el-divider__text {
  color: #6C82A9;
  font: 20px Arial bold;
}

.el-divider {
  background-color: #154480;
}
</style>
